import { useState } from "react";
import { ChevronLeft, ChevronRight, Download, FileText } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import file1 from "../assets/Pdf/Notice for Open House 28Feb 2025.pdf";
import file2 from "../assets/Pdf/OpenHouseOfficeMemorandum31JAN2025.pdf";
import file3 from "../assets/Pdf/digital RC OM.pdf";
import file4 from "../assets/Pdf/OM for Rationalization of FE Registration Process.pdf";
import file5 from "../assets/Pdf/Gazette-Notification-and-SoPs-for-introduction-of-Credit-Insurance-(CI)-to-provide-financial-security.pdf";
import file6 from "../assets/Pdf/Advisory for Beirut.png";

const circulars = [
  { date: "Feb 20, 2025",  title: "Notice for Open House 28 Feb 2025",                                                       isNew: true,  file: file1 },
  { date: "Jan 28, 2025",  title: "Office Memorandum on Open House – January 2025",                                           isNew: true,  file: file2 },
  { date: "Jan 17, 2025",  title: "Digital RC OM",                                                                             isNew: true,  file: file3 },
  { date: "Nov 4, 2024",   title: "OM for Rationalization of FE Registration Process",                                        isNew: false, file: file4 },
  { date: "Oct 4, 2024",   title: "Gazette Notification – Credit Insurance (CI) for financial security…",                    isNew: false, file: file5 },
  { date: "Oct 1, 2024",   title: "Advisory for Indian Nationals traveling to/residing in Lebanon",                           isNew: false, file: file6 },
];

export default function LatestCirculars() {
  const [index, setIndex] = useState(0);
  const [dir, setDir] = useState(1);
  const visibleItems = typeof window !== "undefined" && window.innerWidth < 768 ? 1 : 3;
  const maxIndex = Math.max(0, circulars.length - visibleItems);

  const goNext = () => {
    if (index >= maxIndex) return;
    setDir(1); setIndex((p) => Math.min(p + 1, maxIndex));
  };
  const goPrev = () => {
    if (index <= 0) return;
    setDir(-1); setIndex((p) => Math.max(p - 1, 0));
  };

  const handleDownload = (file) => {
    const link = document.createElement("a");
    link.href = file;
    link.download = file.split("/").pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <span className="text-xs font-bold uppercase tracking-widest text-emerald-600">Documents</span>
          <h2 className="text-2xl md:text-3xl font-extrabold text-blue-950 mt-1">
            Latest <span className="text-emerald-500">Circulars</span>
          </h2>
        </div>
        <div className="flex gap-2">
          <button onClick={goPrev} disabled={index === 0} aria-label="Previous" className="w-9 h-9 flex items-center justify-center rounded-full border border-slate-200 bg-white hover:bg-emerald-50 hover:border-emerald-200 text-slate-500 hover:text-emerald-700 disabled:opacity-30 transition-all duration-200">
            <ChevronLeft size={17} />
          </button>
          <button onClick={goNext} disabled={index >= maxIndex} aria-label="Next" className="w-9 h-9 flex items-center justify-center rounded-full border border-slate-200 bg-white hover:bg-emerald-50 hover:border-emerald-200 text-slate-500 hover:text-emerald-700 disabled:opacity-30 transition-all duration-200">
            <ChevronRight size={17} />
          </button>
        </div>
      </div>

      <div className="overflow-hidden">
        <div
          className="flex gap-4 transition-transform duration-400"
          style={{ transform: `translateX(calc(-${index} * (100% / ${visibleItems} + 4px / ${visibleItems})))` }}
        >
          {circulars.map((c, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.06, duration: 0.4 }}
              onClick={() => handleDownload(c.file)}
              className="relative flex-shrink-0 cursor-pointer bg-white rounded-2xl border border-slate-100 shadow-sm hover:shadow-md hover:border-sky-200 p-5 transition-all duration-300 group shimmer-card"
              style={{ width: `calc(100% / ${visibleItems} - ${(visibleItems - 1) * 16 / visibleItems}px)` }}
            >
              <div className="h-0.5 absolute top-0 left-0 right-0 rounded-t-2xl bg-gradient-to-r from-sky-400 to-blue-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              {c.isNew && (
                <span className="absolute top-3 right-3 bg-emerald-600 text-white text-[9px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wide">
                  New
                </span>
              )}
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 rounded-xl bg-blue-50 flex items-center justify-center shrink-0 mt-0.5 group-hover:bg-sky-100 transition-colors">
                  <FileText size={16} className="text-emerald-700" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-xs text-slate-400 font-medium mb-1">{c.date}</p>
                  <p className="text-xs font-semibold text-slate-800 leading-snug line-clamp-2 group-hover:text-blue-800 transition-colors">{c.title}</p>
                </div>
              </div>
              <div className="mt-3 flex items-center gap-1 text-emerald-600 group-hover:text-sky-700 text-xs font-semibold">
                <Download size={12} />
                Download
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
